<template>
  <v-container fluid>
    <v-card v-show="!loading">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Cadastro de Administrador</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="primary lighten-3"
          @click="$router.push('/administradores')"
          :disabled="salvando"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          class="ml-2"
          color="primary lighten-5"
          @click="salvar"
          :loading="salvando"
          :disabled="!form_valid"
          >Salvar</v-btn
        >
      </v-app-bar>

      <v-form ref="form" v-model="form_valid" lazy-validation>
        <v-container fluid class="pa-2">
          <v-row v-show="loading">
            <v-col
              class="ma-6 pa-6"
              style="display: flex; align-items: center; justify-content: center; text-align: center"
            >
              <v-progress-circular
                size="64"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col class="px-3 py-0">
              <v-text-field
                label="Nome"
                ref="nome"
                v-model="administrador.nome"
                :rules="regras.nome"
                @keypress.native.enter="$refs.cnpj.focus()"
                autofocus
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" class="px-3 py-0">
              <v-text-field
                label="Logradouro"
                ref="rua"
                v-model="administrador.endereco.rua"
                @keypress.native.enter="$refs.numero.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" class="px-3 py-0">
              <v-text-field
                label="Número"
                ref="numero"
                v-model="administrador.endereco.numero"
                @keypress.native.enter="$refs.complemento.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="px-3 py-0">
              <v-text-field
                label="Complemento"
                ref="complemento"
                v-model="administrador.endereco.complemento"
                @keypress.native.enter="$refs.bairro.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="px-3 py-0">
              <v-text-field
                label="Bairro"
                ref="bairro"
                v-model="administrador.endereco.bairro"
                @keypress.native.enter="$refs.cep.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="2" class="px-3 py-0">
              <v-text-field
                label="CEP"
                ref="cep"
                :return-masked-value="true"
                v-model="administrador.endereco.cep"
                @keypress.native.enter="$refs.estado.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="px-3 py-0">
              <v-autocomplete
                :items="estados"
                label="Estado"
                ref="estado"
                v-model="administrador.endereco.estado_id"
                @change="carregarCidades"
                :rules="regras.estado"
                @keypress.native.enter="$refs.cidade.focus()"
                autocomplete="off"
                role="presentation"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" class="px-3 py-0">
              <v-autocomplete
                :items="cidades"
                label="Cidade"
                ref="cidade"
                v-model="administrador.endereco.cidade_id"
                :loading="loading_cidades"
                :rules="regras.cidade"
                @keypress.native.enter="$refs.email.focus()"
                autocomplete="off"
                role="presentation"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="3" class="px-3 py-0">
              <v-text-field
                label="Telefone"
                name="telefone"
                ref="telefone"
                :return-masked-value="true"
                v-model="administrador.endereco.telefone"
                @keypress.native.enter="$refs.celular.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="px-3 py-0">
              <v-text-field
                label="Celular"
                name="celular"
                ref="celular"
                :return-masked-value="true"
                v-model="administrador.endereco.celular"
                @keypress.native.enter="$refs.usuario.focus()"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              :sm="!$route.params.administrador_id ? '4' : '6'"
              class="px-3 py-0"
            >
              <v-text-field
                label="Email"
                ref="usuario"
                v-model="administrador.user.email"
                :rules="regras.usuario"
                @keypress.native.enter="salvar"
                :disabled="!!$route.params.administrador_id"
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              class="px-3 py-0"
              v-if="!$route.params.administrador_id"
            >
              <v-text-field
                label="Senha"
                ref="senha"
                v-model="senha"
                @keypress.native.enter="salvar"
                disabled
                readonly
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/services.js";
import ServiceAdministradores from "@/services/administradores.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "AdministradoresForm",
  mixins: [validadores],
  data() {
    return {
      loading: false,
      loading_cidades: false,
      salvando: false,
      form_valid: true,
      administrador: {
        nome: "",
        cnpj: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
          cidade_id: "",
          estado_id: "",
        },
        user: {
          email: "",
        },
      },
      regras: {
        nome: [(value) => !!value || "Campo Obrigatório"],
        usuario: [(value) => !!value || "Campo Obrigatório"],
      },
      estados: [],
      cidades: [],
      senha: "123456",
    };
  },
  mounted() {
    if (this.$route.params.administrador_id) {
      this.editar(this.$route.params.administrador_id);
    }
    this.estados = Services.estados();
  },
  methods: {
    async editar(administrador_id) {
      try {
        this.loading = true;
        let response = await ServiceAdministradores.editar(administrador_id);
        this.administrador = response.data.administrador;
        /* if (this.administrador.estado_id) {
          this.carregarCidades();
        } */
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao editar administrador");
      } finally {
        this.loading = false;
      }
    },
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.salvando = true;
          this.administrador.endereco.email = this.administrador.user.email;
          if (this.$route.params.administrador_id) {
            await ServiceAdministradores.atualizar(this.administrador);
            this.$eventbus.notificar("Administrador atualizado com sucesso");
          } else {
            await ServiceAdministradores.salvar(this.administrador);
            this.$eventbus.notificar("Administrador salvo com sucesso");
          }
          this.$router.push("/administradores");
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao salvar administrador");
        } finally {
          this.salvando = false;
        }
      }
    },
    async carregarCidades() {
      try {
        this.loading_cidades = true;
        let cidades = await Services.cidades(
          this.administrador.endereco.estado_id
        );
        this.cidades = cidades.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar cidades");
      } finally {
        this.loading_cidades = false;
      }
    },
  },
};
</script>

<style></style>
